// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"9cdb9ac3","436":"07847499","437":"b66ade3d","474":"a9f7bce9","511":"3365fa71","895":"8fd61591","936":"8c7648b2"}[chunkId] + ".chunk.js";
};